import { marketingRoutes } from "./marketing.ts";
import { marketingAliasRoutes } from "./marketing-aliases.ts";
import { productAccountRoutes } from "./product/account.ts";
import { productCommunityRoutes } from "./product/community.ts";
import { productCreationRoutes } from "./product/creation.ts";
import { productPlayRoutes } from "./product/play.ts";
import { gameDocumentRoutes } from "./game-documents.ts";
import { adminPersonalRoutes } from "./admin/personal.ts";
import { adminWorkspaceRoutes } from "./admin/workspace.ts";
import { docsRoutes } from "./docs.ts";
import { officeRoutes } from "./office.ts";
import { resourcesRoutes } from "./resources.ts";
import { gameRoutes } from "./game.ts";
import { adminPeopleRoutes } from "./admin/people.ts";
import { adminLeaguesRoutes } from "./admin/leagues.ts";
import { adminPoliciesRoutes } from "./admin/policies.ts";
import { adminResearchRoutes } from "./admin/research.ts";
import { adminCoworldsRoutes } from "./admin/coworlds.ts";
import { adminUsageRoutes } from "./admin/usage.ts";
import { adminOperationsRoutes } from "./admin/operations.ts";
import { adminCommunityRoutes } from "./admin/community.ts";

export const routeCatalog = {
  ...marketingRoutes,
  ...marketingAliasRoutes,
  ...productAccountRoutes,
  ...productCommunityRoutes,
  ...productCreationRoutes,
  ...productPlayRoutes,
  ...adminWorkspaceRoutes,
  ...docsRoutes,
  ...officeRoutes,
  ...resourcesRoutes,
  ...gameRoutes,
  ...gameDocumentRoutes,
  ...adminPeopleRoutes,
  ...adminPersonalRoutes,
  ...adminLeaguesRoutes,
  ...adminPoliciesRoutes,
  ...adminResearchRoutes,
  ...adminCoworldsRoutes,
  ...adminUsageRoutes,
  ...adminOperationsRoutes,
  ...adminCommunityRoutes,
} as const;
